/*

  ==== JUST TEMPLATE DON'T DELETE IT ====

*/
import $axios from "../../api";
import axios from "axios"; // raw — PUT langsung ke Spaces (tanpa interceptor/baseURL app)
import { dataUrlToBlob, isFreshDataUrl } from "../../utils/spacesUpload";

// MODULE NAME
const module = "website/health-tools";

const state = () => ({
  isLoading: false,
  isErrors: "",
  page: 1,
  isSuccess: false,
  message: "",
  list: null,
  detail: null,
  categories: [],
  // Referensi makanan tinggi protein tool 12 (P26_0032 / FR-07). Dua tab modal;
  // bentuknya selalu lengkap supaya komponen tak perlu guard sebelum me-loop.
  foodList: { hewani: [], nabati: [] },
});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.isErrors = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_IS_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_MESSAGE(state, payload) {
    state.message = payload;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_DETAIL(state, payload) {
    state.detail = payload;
  },
  SET_CATEGORIES(state, payload) {
    state.categories = payload;
  },
  SET_FOOD_LIST(state, payload) {
    state.foodList = {
      hewani: payload?.hewani ?? [],
      nabati: payload?.nabati ?? [],
    };
  },
};

/**
 * Satu penanganan bersama untuk keempat mutasi referensi makanan
 * (P26_0032 / FR-07) dan severity keluhan (P26_0038): alert global saat gagal,
 * dan nilai balik ringkas supaya komponen cukup memeriksa `ok` tanpa menangkap
 * exception sendiri.
 *
 * 403 di sini hampir selalu berarti modul `healthtools_food*` belum di-grant ke
 * role si admin — bukan bug kode. Pesan servernya diteruskan apa adanya lewat
 * globalSweetAlert supaya kelihatan.
 */
const foodMutation = async (dispatch, path, payload) => {
  try {
    const res = await $axios.post(`${module}/${path}`, payload);
    return { ok: true, message: res?.data?.message };
  } catch (error) {
    dispatch("Main/globalSweetAlert", error.response, { root: true });
    return { ok: false, errors: error?.response?.data?.errors };
  }
};

const actions = {
  getList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(
          `${module}/list?page=${state.page}&view=${rootState.Main.view}${
            payload || ""
          }`
        )
        .then((res) => {
          commit("SET_LIST", res.data.data);
          commit("SET_CATEGORIES", res.data.categories ?? []);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  getListUserResult({ commit, state, rootState, dispatch }, payload = {}) {
    commit("SET_LOADING", true);

    return $axios
      .get(`${module}/user-result`, {
        params: {
          page: state.page,
          view: rootState.Main.view,
          ...payload
        }
      })
      .then((res) => {
        commit("SET_LIST", res.data.data);
        commit("SET_LOADING", false);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        dispatch("Main/globalSweetAlert", error.response, {
          root: true,
        });
      });
  },
  getDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${module}/view?id=${payload}`)
        .then((res) => {
          commit("SET_DETAIL", res.data.data);
          commit("SET_LOADING", false);
          resolve(res.data);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          resolve({});
        });
    });
  },
  create({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .put(`${module}/create`, payload)
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
  updateFaq({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${module}/update-faq`, payload)
        .then((res) => {
          commit("SET_MESSAGE", res.data.message);
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
          resolve(res.data);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          reject(error);
        });
    });
  },
  updateResult({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${module}/update-result`, payload)
        .then((res) => {
          commit("SET_MESSAGE", res.data.message);
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
          resolve(res.data);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
          resolve(error);
        });
    });
  },
  // Simpan satu health_result secara "senyap" untuk bulk save: tanpa
  // globalSweetAlert (agar N gagal tak jadi N alert) & tanpa toggle loading
  // (hindari flicker form). Selalu resolve dengan status ringkas.
  async bulkUpdateResult({}, payload) {
    try {
      await $axios.post(`${module}/update-result`, payload);
      return { ok: true };
    } catch (error) {
      return {
        ok: false,
        errors: error?.response?.data?.errors,
        status: error?.response?.status,
      };
    }
  },
  // Jalur 3 — minta presigned PUT URL ke server: { upload_url, headers, filename, public_url }.
  presign({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      $axios
        .post(`${module}/presign`, payload)
        .then((res) => resolve(res.data.data))
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  // PUT file mentah LANGSUNG ke Spaces (browser → DigitalOcean, tidak lewat server app).
  // Instance axios BERSIH: buang header default app (X-Requested-With, X-CSRF-TOKEN,
  // Accept) yang akan memicu preflight CORS yang ditolak Spaces.
  uploadToSpaces(_ctx, { uploadUrl, file, headers }) {
    const s3 = axios.create();
    s3.defaults.headers.common = {};
    s3.defaults.headers.put = {};
    return s3.put(uploadUrl, file, {
      headers: headers || { "Content-Type": file.type || "application/octet-stream" },
      transformRequest: [(d) => d],
    });
  },
  // Upload gambar tool 9 (HPL) ke folder Spaces milik Health Tools sendiri
  // (CDN_HEALTH_TOOLS) — bukan lagi imagestorage/generate-image-link yang tetap
  // dipakai article. Nilai non-base64 (URL lama yang tidak diubah / kosong)
  // diteruskan apa adanya; hanya data URL segar yang di-upload. Mengembalikan
  // nama file, yang memang bentuk simpan kolomnya.
  async uploadImageStorage({ dispatch }, value) {
    if (!isFreshDataUrl(value)) return value;

    const { blob, extension, contentType } = dataUrlToBlob(value);
    const presigned = await dispatch("presign", {
      extension,
      content_type: contentType,
    });
    await dispatch("uploadToSpaces", {
      uploadUrl: presigned.upload_url,
      file: blob,
      headers: presigned.headers,
    });

    return presigned.filename;
  },
  // ---- Referensi makanan tinggi protein (P26_0032 / FR-07) ----
  //
  // Menyunting baris yang SAMA yang dibaca `GET /health-tools/food-list` di
  // nfapiv2 (AC-07.3: satu sumber di server), jadi perubahan di sini langsung
  // terlihat di modal hasil tool 12 di web & aplikasi.

  async getFoodList({ commit, dispatch }, toolId = 12) {
    try {
      const res = await $axios.get(`${module}/food-list`, {
        params: { tool_id: toolId },
      });
      commit("SET_FOOD_LIST", res?.data?.data);
      return true;
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
      // Daftar dikosongkan supaya tab tidak menampilkan sisa data lama yang
      // sudah tak mencerminkan server.
      commit("SET_FOOD_LIST", null);
      return false;
    }
  },
  storeFood({ dispatch }, payload) {
    return foodMutation(dispatch, "food-store", payload);
  },
  updateFood({ dispatch }, payload) {
    return foodMutation(dispatch, "food-update", payload);
  },
  showHideFood({ dispatch }, id) {
    return foodMutation(dispatch, "food-showhide", { id });
  },
  deleteFood({ dispatch }, id) {
    return foodMutation(dispatch, "food-delete", { id });
  },
  // Severity keluhan berbahaya (P26_0038 §3.6): { option_id, score_value 1|2 }.
  // Bentuk balikan sama dengan mutasi makanan — { ok, message } / { ok: false }.
  // 403 = modul `healthtools_updateseverity` belum di-grant ke role si admin.
  updateSeverity({ dispatch }, payload) {
    return foodMutation(dispatch, "update-severity", payload);
  },
  showHide({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${module}/showhide`, { id: payload })
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
